import { forwardRef } from "react";

import { Tile, type TileProps } from "../../../../modules/core/components/Tile.js";

type GenericTileProps = Pick<
  TileProps,
  | "title"
  | "type"
  | "footNote"
  | "dates"
  | "users"
  | "project"
  | "tags"
  | "to"
  | "onPress"
  | "forceExternal"
  | "children"
  | "icon"
>;

/**
 * A Generic tile to be used for SavedItems References or any other default cases.
 */
const GenericTile = forwardRef<HTMLDivElement, GenericTileProps>(function GenericTile(props, ref) {
  return <Tile {...props} icon={props.icon} ref={ref} />;
});

export { GenericTile };
